module.exports = __webpack_public_path__ + "static/media/view assigned staff in depart.89a17fc9.svg";